var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { Actor_ } from '../../../components/actor/Actor_';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class SkeletonRegistryDraftWordTask extends SkeletonRegistryCategory {
    label = 'WordTask';
    constructor(parent) {
        super(parent);
        super.init();
    }
    static get structureTemplate1() {
        return (React.createElement("div", { "data-aspect": "inner" },
            React.createElement("div", { "data-aspect": "prefix" }),
            React.createElement("div", { "data-aspect": "main" },
                React.createElement("input", { type: "text", "data-aspect": "input" })),
            React.createElement("div", { "data-aspect": "postfix" })));
    }
    defaultWordTask = () => new SkeletonRegistryItem({
        label: 'Wordtask Structure Inner[prefix_main_postfix]',
        jsx: ({ wordTask }) => {
            if (!wordTask)
                return null;
            return React.createElement(Actor_, { actor: wordTask, structureTemplate: SkeletonRegistryDraftWordTask.structureTemplate1 });
        },
    });
    static get defaultWordTaskStructureTemplate() {
        return (React.createElement("div", { "data-aspect": "inner" },
            React.createElement("div", { "data-aspect": "prefix" }),
            React.createElement("div", { "data-aspect": "main" },
                React.createElement("input", { type: "text", "data-aspect": "input" })),
            React.createElement("div", { "data-aspect": "postfix" })));
    }
    static get structureTemplate2() {
        return React.createElement("input", { type: "text" });
    }
    wordtaskStructure_absolute = () => new SkeletonRegistryItem({
        label: 'Wordtask Structure actors absolute',
        jsx: ({ wordTask }) => {
            if (!wordTask)
                return null;
            return (React.createElement(React.Fragment, null,
                wordTask.ownAspect.prefix.aspectContent.global.activeContentAts.map(at => (React.createElement(Actor_, { actor: at, key: at.id }))),
                React.createElement(Aspect_, { aspect: wordTask.ownAspect.input, templateComponent: SkeletonRegistryDraftWordTask.structureTemplate2 }),
                wordTask.ownAspect.postfix.aspectContent.global.activeContentAts.map(at => (React.createElement(Actor_, { actor: at, key: at.id })))));
        },
    });
}
__decorate([
    memoize
], SkeletonRegistryDraftWordTask, "structureTemplate1", null);
__decorate([
    memoize
], SkeletonRegistryDraftWordTask, "defaultWordTaskStructureTemplate", null);
__decorate([
    memoize
], SkeletonRegistryDraftWordTask, "structureTemplate2", null);
